module.exports = __webpack_public_path__ + "images/uncharted-4_rgba(0,0,0,0.7).007eb5cd4c7a89a1e47cb56c48a593c0.jpg";